// extracted by mini-css-extract-plugin
export var modal = "_t5-0";
export var table = "_t5-1";